import React from "react";
import "./Footer.css"
import {SocialBar} from "./elements/socialbar/SocialBar";
import {loadImage} from "./elements/util/ImageLoder";
import zakaz from "../resources/social/zakaz.svg";


let text =
    "\t+380-50-407-73-14(Viber)\n" +
    "E-mail:  horecagelato@gmail.com\n";
export class Footer extends React.Component<any, any>{


    constructor(props: Readonly<any>) {
        super(props);
        let contactString;
        let language = localStorage.getItem("language");
        if (language === "ua") {
            contactString = "Контакти"
        } else if (language === "ru") {
            contactString = "Контакты"
        } else if (language === "uk") {
            contactString = "Contacts"
        }
        
        text = contactString + ":\n" + text;

        this.state = {
            logo: ""
        };
    }

    componentDidMount(): void {
        loadImage("logo.webp").then(res => {
            this.setState((state: any) => {
                let stateTmp = state;
                stateTmp.logo = res.default;
                return {
                    stateTmp
                };
            });
        });
    }

    render(){
        return(
            <footer className="footer">
                <div className="footer__inner">
                    <a className="footer__zakaz" href="https://zakaz.ua/uk/search/?q=La%20gelateria&tm=la-gelateria" target="_blank"
                       rel="noopener noreferrer" aria-label={"zakaz.ua"}>
                        <img className="footer__zakaz__logo" src={zakaz} alt="zakaz.ua"/>
                    </a>
                    <SocialBar/>
                    <img className="footer__logo" src={this.state.logo} alt=""/>
                    <div className= "footer__contacts">{text}</div>
                </div>
            </footer>
        )
    }

}
